import ModalSendSurvey from "./ModalSendSurvey";

export default ModalSendSurvey;